module.exports = __webpack_public_path__ + "img/phone-conect.4ba7127d.svg";